import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  body {
    min-width: 320px;
    background: #f9f9f9;
    width: 100%;
  }
  #identifyYourAccountForm\\.accountNumber, #identifyYourAccountForm\\.firstName, #identifyYourAccountForm\\.dob, #identifyYourAccountForm\\.lastName, #debitDetails\\.cardName {
    /* border: none; */
    box-shadow: none !important;
    &[aria-invalid='true'] {
      border: 1px solid #e52a00;
      color: #e52a00;
    }
  }
  #error-identifyYourAccountForm\\.accountNumber, #error-identifyYourAccountForm\\.firstName, #error-identifyYourAccountForm\\.dob, #error-identifyYourAccountForm\\.lastName,#error-debitDetails\\.cardName {
    color: #e52a00;
  }
`;

export default GlobalStyle;
